export default "__VITE_ASSET__dc9ca7f0__"